import { MessageCircle, Camera, Brush } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  {
    icon: MessageCircle,
    num: "01",
    title: "We Talk",
    text: "Every portrait opens with a consultation — in person preferably, or by email or phone call. Tell me who they are: the quirks, the habits, the look they give you.",
  },
  {
    icon: Camera,
    num: "02",
    title: "You Curate",
    text: "Share one clear headshot and as many candid shots as you like, and choose your background and accent colors.",
  },
  {
    icon: Brush,
    num: "03",
    title: "I Paint",
    text: "From your photos, the stories you tell, and — whenever we can — an in-person consultation with your pet, I convene with it all and listen for how your pet wishes to be presented in their portrait. Then I paint: layer by layer, signed, and shipped to your door.",
  },
];

export const Process = () => (
  <section id="process" data-testid="process-section" className="relative py-28 sm:py-36">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal><Eyebrow>From Hello to Heirloom</Eyebrow></Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-5 max-w-2xl font-serif tracking-tight leading-[1.08] text-3xl sm:text-4xl lg:text-5xl text-[#EAF5FA]">
          Three steps. <span className="gold-foil-text italic">Zero shortcuts.</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid md:grid-cols-3 gap-6">
        {STEPS.map((s, i) => (
          <Reveal key={s.num} delay={0.15 + i * 0.12}>
            <div
              data-testid={`process-step-${i + 1}`}
              className="group relative h-full p-8 rounded-2xl bg-[#1F1B17] border border-[#2E2721] hover:border-[#41C2F2]/50 transition-colors duration-500"
            >
              <span className="font-serif italic text-6xl text-[#41C2F2]/15 group-hover:text-[#41C2F2]/30 transition-colors duration-500">{s.num}</span>
              <s.icon className="w-6 h-6 text-[#41C2F2] mt-6" />
              <h3 className="mt-4 font-serif text-2xl text-stone-100">{s.title}</h3>
              <p className="mt-3 text-sm text-stone-400 leading-relaxed">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.3}>
        <blockquote data-testid="process-listening-quote" className="mt-20 max-w-3xl mx-auto text-center">
          <span className="text-[#41C2F2] text-xs">✦</span>
          <p className="mt-5 font-serif italic text-xl sm:text-2xl leading-relaxed text-stone-200">
            "Sometimes the answer surprises — but you may find you've known all along: the St.&nbsp;Bernard
            trapped in a Chihuahua's body, or the tough-exterior Pit Bull who is, at heart, a teacup princess."
          </p>
          <footer className="mt-5 text-xs uppercase tracking-[0.3em] font-mono text-stone-500">— Listening at the easel</footer>
        </blockquote>
      </Reveal>
    </div>
  </section>
);
